import { initInputObserver, initMutationObserver } from './observers';
export var initShadowRootsController = function initShadowRootsController(configuration, _a) {
  var mutationCb = _a.mutationCb,
    inputCb = _a.inputCb;
  var controllerByShadowRoot = new Map();
  var shadowRootsController = {
    addShadowRoot: function addShadowRoot(shadowRoot) {
      var _a = initMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot),
        stopMutationObserver = _a.stop,
        flush = _a.flush;
      // the change event no do bubble up across the shadow root, we have to listen on the shadow root
      var stopInputObserver = initInputObserver(configuration, inputCb, shadowRoot);
      controllerByShadowRoot.set(shadowRoot, {
        flush: flush,
        stop: function stop() {
          stopMutationObserver();
          stopInputObserver();
        }
      });
    },
    removeShadowRoot: function removeShadowRoot(shadowRoot) {
      var entry = controllerByShadowRoot.get(shadowRoot);
      if (!entry) {
        // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
        return;
      }
      entry.stop();
      controllerByShadowRoot.delete(shadowRoot);
    },
    stop: function stop() {
      controllerByShadowRoot.forEach(function (_a) {
        var stop = _a.stop;
        return stop();
      });
    },
    flush: function flush() {
      controllerByShadowRoot.forEach(function (_a) {
        var flush = _a.flush;
        return flush();
      });
    }
  };
  return shadowRootsController;
};